import env from 'dux/env';
import error from 'dux/errors';
import user from 'dux/user';
import appRouterReducer, { ROOT_KEY as APP_ROUTER_ROOT_KEY } from 'dux/router';
import { router } from 'dux/router/router';

import contactUs from 'routes/contact/contact-dux';
import profile from 'routes/profile/profile-dux';
import welcome from 'routes/welcome/welcome-dux';

export const reducers = {
    location: router.reducer,
    [ APP_ROUTER_ROOT_KEY ]: appRouterReducer,
    error,
    env,
    user,
    contactUs,
    profile,
    welcome,
};
